/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import useCountdown from '../../hooks/useCountDown';
import ExpiredNotice from './ExpiredNotice';
import './CountdownTimer.scss';

function CountdownTimer({ targetDate, continueBtnText, continueRoutePath }) {
  const [days, hours, minutes, seconds] = useCountdown(targetDate);

  if (days + hours + minutes + seconds <= 0) {
    return (
      <ExpiredNotice
        continueBtnText={continueBtnText}
        continueRoutePath={continueRoutePath}
      />
    );
  }

  return (
    <div className="countdown-timer">
      <div className="text-center">
        {/* <small>Your session will expire in</small> */}
        <div
          className={
            minutes < 1
              ? 'countdown-timer__timer countdown-timer__danger'
              : 'countdown-timer__timer'
          }
        >
          <div>
            <span className="me-1">{minutes}</span>
            <span>:</span>
            <span className="ms-1">{seconds.toString().padStart(2, '0')}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

CountdownTimer.propTypes = {
  targetDate: PropTypes.any.isRequired,
  continueBtnText: PropTypes.string.isRequired,
  continueRoutePath: PropTypes.string.isRequired,
};

export default CountdownTimer;
